import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Box } from "@UI/Components/Box/Box";
import { Card } from "@UI/Components/Card/Card";
import { PaymentError } from "@modules/Purchasing/Components/OrderDescription/PaymentError/PaymentError";
import React, { FC } from "react";
import messages from "./messages";
import { FAQSection } from "@modules/CustomerSupport/Components/FAQSection/FAQSection";

export const CancelledServiceOffer: FC = () => {
  return (
    <Box margin={4}>
      <Card mb={5}>
        <PaymentError
          title={<FormattedMessage {...messages.serviceOfferCancelled} />}
        />
      </Card>
      <FAQSection />
    </Box>
  );
};
